import { useNormalizedPixels } from '../../../../../hooks/useResize';
import { getScaleSize } from '../../../../../utils/utils';

interface BrandLogoProps {
  scale: number;
  src: string;
  isLayoutOne: boolean;
}

const BrandLogo = ({ scale, src, isLayoutOne }: BrandLogoProps) => {
  const { normalizePixels } = useNormalizedPixels();
  return (
    <div
      id="template1-logo"
      style={{
        width: isLayoutOne ? '48%' : '30%',
        height: getScaleSize(normalizePixels(112, 'height'), scale),
        display: 'flex',
        justifyContent: 'flex-start',
        marginBottom: getScaleSize(normalizePixels(8, 'height'), scale),
      }}
    >
      <img
        src={src}
        alt="Brand logo"
        style={{
          objectFit: 'contain',
          objectPosition: 'left',
          height: '100%',
          maxWidth: '100%',
          alignSelf: 'flex-start',
        }}
      />
    </div>
  );
};

export default BrandLogo;
